import { StatBarWrapper, StatBarWrapperProps } from "./stat-bar-wrapper";
import { Stack } from "@chakra-ui/react";
import { LoadingDots } from "@ui/loading";

export interface StatBarLoadingProps extends StatBarWrapperProps {}

export const StatBarLoading = (props: StatBarLoadingProps) => {
  return (
    <StatBarWrapper {...props}>
      <Stack align="center" justify="center" w="100%">
        <LoadingDots color="white" />
      </Stack>
    </StatBarWrapper>
  );
};
